module.exports = __webpack_public_path__ + "static/fcra-fin-2017-18-5ba1b78eca6ed519d8a63f823f6f8251.pdf";